// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__y3cBZ","box":"WorkspacesBox_box__2v4_A","node":"WorkspacesBox_node__1N3dk"};